function SearchTypewriter(inputEl) {
  var prefix = inputEl.dataset.twPrefix || "";
  var terms = [];
  try { terms = JSON.parse(inputEl.dataset.twTerms || "[]"); } catch (e) {}

  var termIndex = 0;
  var charIndex = prefix.length;
  var phase = "typing"; // typing | holding | erasing | pausing
  var timer = null;
  var running = false;

  function currentTarget() {
    return terms.length ? prefix + terms[termIndex % terms.length] : prefix;
  }

  function tick() {
    if (!running) return;

    if (phase === "typing") {
      var target = currentTarget();
      charIndex = Math.min(charIndex + 1, target.length);
      inputEl.placeholder = target.slice(0, charIndex);
      if (charIndex >= target.length) {
        phase = "holding";
        timer = setTimeout(tick, 1800);
      } else {
        timer = setTimeout(tick, 110);
      }

    } else if (phase === "holding") {
      phase = "erasing";
      timer = setTimeout(tick, 110);

    } else if (phase === "erasing") {
      charIndex = Math.max(charIndex - 1, prefix.length);
      inputEl.placeholder = currentTarget().slice(0, charIndex);
      if (charIndex <= prefix.length) {
        termIndex = (termIndex + 1) % (terms.length || 1);
        phase = "pausing";
        timer = setTimeout(tick, 500);
      } else {
        timer = setTimeout(tick, 110);
      }

    } else if (phase === "pausing") {
      charIndex = prefix.length;
      phase = "typing";
      timer = setTimeout(tick, 80);
    }
  }

  this.start = function () {
    if (!terms.length) return;
    if (running) {
      if (!inputEl.placeholder) {
        inputEl.placeholder = currentTarget().slice(0, Math.max(charIndex, prefix.length));
      }
      return;
    }
    running = true;
    charIndex = prefix.length;
    inputEl.placeholder = prefix;
    timer = setTimeout(tick, 600);
  };

  this.stop = function () {
    running = false;
    clearTimeout(timer);
    inputEl.placeholder = "";
  };
}

function initSearchBox(inputId, popupId, contentId, spinnerId) {
  var searchInput = document.getElementById(inputId);
  var searchPopup = document.getElementById(popupId);
  var searchContent = document.getElementById(contentId);
  var searchSpinner = document.getElementById(spinnerId);

  if (!searchInput || !searchPopup || !searchContent) return;

  var searchWrapper = searchInput.closest(".st-desktop-searchbox");
  var crossBtn = searchWrapper ? searchWrapper.querySelector(".st-cross") : null;
  var backBtn = searchWrapper ? searchWrapper.querySelector(".st-search-back") : null;

  var defaultContent = searchContent.innerHTML;
  var debounceTimer = null;
  var activeRequestId = 0;

  var typewriter = new SearchTypewriter(searchInput);
  typewriter.start();

  function openPopup() {
    searchPopup.removeAttribute("aria-hidden");
    searchPopup.classList.add("st-popup-open");
    if (searchWrapper) {
      searchWrapper.classList.add("st-search-open");
    }
  }

  function closePopup() {
    searchPopup.setAttribute("aria-hidden", "true");
    searchPopup.classList.remove("st-popup-open");
    if (searchWrapper) {
      searchWrapper.classList.remove("st-search-open");
    }
  }

  function cancelPending() {
    activeRequestId += 1;
  }

  function showSpinner() {
    if (searchSpinner) {
      searchSpinner.classList.add("st-spinner-visible");
      searchSpinner.removeAttribute("aria-hidden");
    }
    searchContent.style.display = "none";
  }

  function hideSpinner() {
    if (searchSpinner) {
      searchSpinner.classList.remove("st-spinner-visible");
      searchSpinner.setAttribute("aria-hidden", "true");
    }
    searchContent.style.display = "";
  }

  function revertToDefault() {
    cancelPending();
    hideSpinner();
    searchContent.innerHTML = defaultContent;
  }

  function resetAndCloseSearch() {
    searchInput.value = "";
    if (crossBtn) crossBtn.style.display = "none";
    clearTimeout(debounceTimer);
    revertToDefault();
    closePopup();
    searchInput.blur();
    typewriter.start();

    if (searchWrapper) {
      searchWrapper.classList.remove("st-mobile-open");
    }

    var mobileSearchIcon = document.querySelector(".st-icons .st-search-icon");
    var mobileCloseIcon = document.querySelector(".st-icons .close-ul");
    if (mobileSearchIcon) mobileSearchIcon.style.display = "";
    if (mobileCloseIcon) mobileCloseIcon.style.display = "none";
  }

  async function fetchSearchResults(query) {
    cancelPending();
    var requestId = activeRequestId;

    showSpinner();

    var url =
      "/search/suggest" +
      "?q=" + encodeURIComponent(query) +
      "&resources[type]=product,query" +
      "&resources[limit]=6" +
      "&resources[limit_scope]=each" +
      "&resources[options][unavailable_products]=hide" +
      "&resources[options][fields]=body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor" +
      "&section_id=st-predictive-search";

    try {
      var response = await fetch(url);
      if (!response.ok) return;
      var html = await response.text();
      if (requestId !== activeRequestId) return;
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      var sectionEl = doc.getElementById("shopify-section-st-predictive-search");
      if (sectionEl) {
        searchContent.innerHTML = sectionEl.innerHTML;
      }
    } catch (err) {
      console.error("[Search] Fetch error:", err);
    } finally {
      if (requestId === activeRequestId) {
        hideSpinner();
      }
    }
  }

  searchInput.addEventListener("input", function () {
    var query = this.value.trim();
    openPopup();
    if (crossBtn) crossBtn.style.display = query ? "block" : "none";
    if (query) {
      typewriter.stop();
    } else {
      typewriter.start();
    }
    clearTimeout(debounceTimer);
    if (!query) {
      revertToDefault();
      return;
    }
    debounceTimer = setTimeout(function () {
      fetchSearchResults(query).catch(function () {});
    }, 300);
  });

  searchInput.addEventListener("focus", function () {
    openPopup();
    if (this.value.trim()) typewriter.stop();
  });

  searchInput.addEventListener("blur", function () {
    if (!this.value.trim()) typewriter.start();
  });

  if (searchWrapper) {
    searchWrapper.addEventListener("st:mobile-search:open", function () {
      openPopup();
      if (!searchInput.value.trim()) typewriter.start();
    });

    searchWrapper.addEventListener("st:mobile-search:close", function () {
      resetAndCloseSearch();
    });
  }

  if (backBtn) {
    backBtn.addEventListener("click", function (e) {
      e.preventDefault();
      resetAndCloseSearch();
    });
  }

  if (crossBtn) {
    crossBtn.addEventListener("click", function () {
      searchInput.value = "";
      crossBtn.style.display = "none";
      clearTimeout(debounceTimer);
      revertToDefault();
      typewriter.start();
      searchInput.focus();
    });
  }

  document.addEventListener("click", function (e) {
    if (searchWrapper && !searchWrapper.contains(e.target)) closePopup();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closePopup();
      searchInput.blur();
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initSearchBox(
    "st-desktop-search-input",
    "st-search-popup",
    "st-search-results-content",
    "st-search-spinner"
  );
});
